import React, { useEffect } from "react";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import {
  CircularProgress,
  Grid,
  List,
} from "@mui/material";
import { useState } from "react";
import { singleUserApi, updateUserDetailsApi } from "backendServices/ApiCalls";
import SweetAlert from "app/pages/components/mui/Alerts/SweetAlert";
import * as yup from "yup";
import { Form, Formik } from "formik";
import Div from "@jumbo/shared/Div/Div";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const validationSchema = yup.object({
  username: yup.string().required("Username is required"),
  first_name: yup.string().required("First name is required"),
  last_name: yup.string().required("Last name is required"),
  email: yup
    .string("Enter email address")
    .email("Invalid email address")
    .required("Email is required"),
  admin_transaction_password: yup
    .string()
    .required("Transaction Password is required"),
});

const UpdatePersonalInfo = () => {
  const { t } = useTranslation();
  const [singleUser, setSingleUser] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [updateRecord, setUpdateRecord] = useState(false);
  const location = useLocation();
  const [alertData, setalertData] = React.useState({
    show: false,
    message: "",
    variant: "",
  });

  const user_id = location?.state?.user_id || "";
  const getSingleUserFunction = () => {
    let params = {
      userid: user_id,
    };

    setIsLoading(true);
    singleUserApi(params, (response) => {
      setSingleUser(response?.data?.data[0]);
      setIsLoading(false);
    });
  };

  const handleSubmit = (data, setSubmitting) => {
    data.userid = user_id;
    updateUserDetailsApi(
      data,
      (response) => {
        if (response?.data?.status === "error") {
          setalertData({
            show: true,
            message: response?.data?.message,
            variant: "error",
          });
          setSubmitting(false);
        } else if (response?.data?.status === "success") {
          setUpdateRecord(false);
          setalertData({
            show: true,
            message: response?.data?.message,
            variant: "success",
          });
          setUpdateRecord(true);
          setSubmitting(false);
        } else {
          setalertData({
            show: true,
            message: "Something went wrong. Please try again leter",
            variant: "error",
          });
        }
      },
      (error) => {}
    );
  };

  useEffect(() => {
    getSingleUserFunction();
  }, [updateRecord]);

  return (
    <Grid
      container
      fullWidth
      sm={12}
      xs={12}
      p={2}
      alignItems="center"
      justifyContent="center"
    >
      <Grid item sm={6} xs={12}>
        <JumboCardQuick title={"Update User Personal Information"} noWrapper>
          {alertData.show && (
            <SweetAlert alertData={alertData} setalertData={setalertData} />
          )}
          {isLoading ? (
            <Div
              sx={{
                mt: "20%",
                ml: "45%",
                mb: "20%",
              }}
            >
              <CircularProgress />
            </Div>
          ) : (
            <List disablePadding sx={{ mb: 2 }}>
              <Formik
                validateOnChange={true}
                initialValues={{
                  username: singleUser?.username,
                  first_name: singleUser?.firstname,
                  last_name: singleUser?.lastname,
                  email: singleUser?.email,
                  admin_transaction_password: "",
                }}
                validationSchema={validationSchema}
                onSubmit={(data, { setSubmitting }) => {
                  setSubmitting(true);
                  handleSubmit(data, setSubmitting);
                }}
              >
                {({ isSubmitting }) => (
                  <Form
                    style={{ textAlign: "left" }}
                    noValidate
                    autoComplete="off"
                  >
                    <Div sx={{ mt: 1, pl: 2, pr: 2 }}>
                      <JumboTextField
                        fullWidth
                        name="username"
                        label="User Name"
                        type="text"
                      ></JumboTextField>
                    </Div>
                    <Div sx={{ mt: 3, mb: 3, pl: 2, pr: 2 }}>
                      <JumboTextField
                        fullWidth
                        name="first_name"
                        label="First Name"
                        type="text"
                      />
                    </Div>

                    <Div sx={{ mt: 3, mb: 3, pl: 2, pr: 2 }}>
                      <JumboTextField
                        fullWidth
                        name="last_name"
                        label="Last Name"
                        type="text"
                      />
                    </Div>

                    <Div sx={{ mt: 3, mb: 3, pl: 2, pr: 2 }}>
                      <JumboTextField
                        fullWidth
                        name="email"
                        label="Email"
                        type="text"
                      />
                    </Div>

                    <Div sx={{ mt: 1, pl: 2, pr: 2 }}>
                      <JumboTextField
                        fullWidth
                        name="admin_transaction_password"
                        label="Transaction Password"
                        type="password"
                      />
                    </Div>

                    <Div sx={{ mt: 1, pl: 2, pr: 2 }}>
                      <LoadingButton
                        fullWidth
                        type="submit"
                        variant="contained"
                        size="large"
                        sx={{ mb: 3 }}
                        loading={isSubmitting}
                      >
                        {t("pages.title.submit")}
                      </LoadingButton>
                    </Div>
                  </Form>
                )}
              </Formik>
            </List>
          )}
        </JumboCardQuick>
      </Grid>
    </Grid>
  );
};

export default UpdatePersonalInfo;
